import { useContext } from 'react';
import { AuthContext } from '@store/AuthContext';
import { getAccessToken, setAccessToken } from '../api/apiClient';

// Hook to use auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Standalone functions for direct import (e.g. in API interceptors)
export const getToken = () => {
  return getAccessToken();
};

export const setToken = (token) => {
  setAccessToken(token);
};

export const removeToken = () => {
  setAccessToken(null);
};

export const isLoggedIn = () => {
  const token = getAccessToken();
  return !!token;
};
